import React from 'react';
import ReactDOM from 'react-dom';
import '../App.css';
import $ from 'jquery';
import config from '.././config.json';
import AddClassForm from './AddClassForm';
import moment from 'moment';
import { Redirect } from 'react-router';
import LoginForm from '../LoginForm.js';
import Calendar from 'react-calendar';

import { Form, Table, Input, Popconfirm, notification, Col, Row, Select } from 'antd';
const Option = Select.Option;

const FormItem = Form.Item;
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
    },
};
class EditClasses extends React.Component {

    state = {
        classEdit: false,
        filterDropdownVisible: false,
        searchText: '',
        filtered: false,
        classData: [],
        updateData: {},
        login: true,
        searchClassData: '',
        // searchClassData:[],
        sortedInfo: null,
        date: new Date(),
        mylist: [],
        searchType: '',
        dateClassData: [],
        filterSystem: "All"
    };


    /* For Calender Show 
     Date: 07/17/2019 
     Author: Souradip Roy */
    calendar = () => {
        $("div.mycalendar").toggle("show");
    }
    /* The next function is to filter the classes based on the date chosen. It filters all the classes that are after a chosen date and is compared
       with the start date of the class. 
       Date: 07/17/2019 
       Author: Souradip Roy */
    oncalenderChange = date => {
        $("div.mycalendar").toggle("hide");
        var dict = {
            "Jan": 1, "Feb": 2, "Mar": 3, "Apr": 4, "May": 5, "Jun": 6, "Jul": 7, "Aug": 8, "Sep": 9, "Oct": 10, "Nov": 11, "Dec": 12
        }
        var searchmonth = (date.toString().slice(4, 7));
        searchmonth = dict[searchmonth];
        var searchday = (date.toString().slice(8, 10));
        var searchyear = (date.toString().slice(11, 15));
        var finaldate = searchyear + "-" + searchmonth + "-" + searchday;
        this.props.form.setFieldsValue({
            ['search']: '',
            ['date']: finaldate
        });
    }
    /* Function Ends */


    componentDidMount() {
        LoginForm.ValidateServerToken(
            () => { this.setState({ login: false }) }, //logout
            () => { this.refresh(); }); //login
    }

    componentWillUnmount() {
        if (!this.state.classEdit) {
            window.location.hash = "/admin/admin";
        }
    }


    refresh() {
        this.ajaxCall('GET', '/api/classes/getall',
            {}, (data) => {//success
                //console.log(data);

                this.setState({
                    classData: data
                })

            }, () => {//fail
                console.log('failed to get data');
            });

    }

    /** 
     * Used for custom ajax calls
     * @param {any} type
     * @param {any} url
     * @param {any} data
     * @param {any} done
     * @param {any} fail
     */
    ajaxCall(type, url, data, done, fail) {
        $.ajax({
            type: type,
            url: `${config.serverUrl}` + url,
            data: data
        })
            .done((data) => {
                done(data);
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                fail();
            });
    }

    // These functions are for the search drop down
    onInputChange = (e) => {
        this.setState({ searchText: e.target.value });
    }

    /* TODO: Implement Search function
    */
    onSearch = () => {

    }


    /**
     * Opends the AddClassForm and populates it with the record to be edited
     * @param {any} record
     */
    edit(record) {
        this.setState({
            updateData: record
        })
        this.showClass();
    }

    /**
     * Deletes the class
     * TODO: Change to not delete but just mark as deleted
     * @param {any} record
     */
    deleteClass(record) {
        this.ajaxCall('POST', '/api/classes/delete/' + record.Id,
            record.Id, (data) => {//success
                this.refresh();
            }, () => {//fail
                this.openNotificationWithIcon('error', 'Failed To Delete', '')
            });
    }

    /**
    * Opens the notification window
    */
    openNotificationWithIcon = (type, title, body) => {
        notification[type]({
            message: title,
            description: body,
        });
    };

    /**
    * Callback for the when a class is updated
    */
    handleOk = (e) => {
        this.refresh();
        this.setState({
            classEdit: false,
            updateData: {}
        });

    }

    /**
    * Displays the form to edit the class that was selected
    */
    showClass = () => {
        this.setState({
            classEdit: true,
        });
    }


    searchClass = () => {
        var dateField = this.props.form.getFieldValue('date')
        var searchField = this.props.form.getFieldValue('search')
        if (dateField !== "" && dateField !== undefined) {
            let data = this.state.classData;
            this.state.mylist = []
            var selecteddate = (new Date(dateField)).toISOString().slice(0, 10);
            for (let i = 0; i < data.length; i++) {
                var startdate = data[i]['StartDate'].slice(0, 10);
                if (startdate == selecteddate) {
                    this.state.mylist.push(data[i])
                }
            }
            this.setState({
                dateClassData: this.state.mylist,
                searchType: 'date',
                searchClassData: ""
            })
        }
        else {
            this.setState({
                searchClassData: searchField,
                searchType: 'search',
                dateClassData: []
            });
        }
    }

    searchClassReset = () => {
        this.props.form.setFieldsValue({
            ['search']: '',
            ['date']: ''
        });
        this.setState({
            searchClassData: '',
            searchType: '',
            dateClassData: []
        });
        this.refresh();

    }

    updateData(searchClass, dateClass, type) {
        let data = this.state.classData;

        if (type === 'date') {
            data = dateClass
        }

        if (type === 'search') {
            const reg = new RegExp(searchClass, 'gi');

            data = data.filter(function (item) {
                if (item.Name.match(reg)) {
                    return true;
                }
            });
        }

        let rtnList = []
        if(this.state.filterSystem!="All"){
            for(let x = 0; x<data.length; x++){
                if(data[x].SystemName == this.state.filterSystem){
                    rtnList.push(data[x])
                }
            }
            console.log(rtnList)
            return rtnList
        }else{
            console.log(data)
            return data;
        }

    }

    handleChangeSort = (pagination, filters, sorter) => {
        this.setState({
            sortedInfo: sorter,
        });
    }

    searchTxtChanged = () => {
        this.props.form.setFieldsValue({
            ['date']: ''
        });
    }

    dateTxtChanged = () => {
        this.props.form.setFieldsValue({
            ['search']: ''
        });
    }

    compareByChar(a, b) { if (a > b) { return -1; } if (a < b) { return 1; } return 0; }

    handleSelectChangeSystem = (value) => {
        this.setState({ filterSystem: value });
        this.updateData(this.state.searchClassData, this.state.dateClassData, this.state.searchType)
    }

    /**
     * Render function
     */
    render() {
        const { getFieldDecorator } = this.props.form;
        let { sortedInfo } = this.state;
        sortedInfo = sortedInfo || {};
        const columns = [
            {
                title: 'Class',
                dataIndex: 'Name',
                // specify the condition of filtering result
                // here is that finding the name started with `value`
                key: 'Name',
                sorter: (a, b) => this.compareByChar(a.Name, b.Name),
                sortOrder: sortedInfo.columnKey === 'Name' && sortedInfo.order
            },

            {
                title: 'Start Date',
                dataIndex: 'StartDate',
                render: (text, record, index) => {
                    return (
                        <span>
                            {moment(text).format('l')}
                        </span>
                    );
                },
                sorter: (a, b) => this.compareByChar(a.StartDate, b.StartDate),
                sortOrder: sortedInfo.columnKey === 'StartDate' && sortedInfo.order,
            },

            {
                title: 'End Date',
                dataIndex: 'EndDate',
                render: (text, record, index) => {
                    return (
                        <span>
                            {moment(text).format('l')}
                        </span>
                    );
                },
                sorter: (a, b) => this.compareByChar(a.EndDate, b.EndDate),
                sortOrder: sortedInfo.columnKey === 'EndDate' && sortedInfo.order,
            },

            {
                title: 'Seats',
                dataIndex: 'Capacity',
                render: (text, record, index) => {
                    // hybrid classes need to account for both capacities
                    if (!record.OnlineCapacity) {
                        return (<span>{text}</span>);
                    } else {
                        return (<span> {parseInt(record.Capacity) + parseInt(record.OnlineCapacity)}</span>)
                    }
                }
            },

            {
                title: 'Action',
                dataIndex: 'edit',
                render: (text, record, index) => {
                    return (
                        <span>
                            <a onClick={() => this.edit(record)}>Edit </a>
                            |
                            <Popconfirm title="Are you sure delete this Class?" onConfirm={() => { this.deleteClass(record) }} okText="Yes" cancelText="No">
                                <a> Delete</a>
                            </Popconfirm>

                        </span>
                    );
                }
            }
        ];
        // render stuff.. finally...
        return (
            <div>
                {
                    this.state.login ?
                        (<div>

                            {/*Edit class form*/}
                            {this.state.classEdit && <AddClassForm updateFields={this.state.updateData} updateEvent={this.handleOk} />}

                            {/*Classes table*/}
                            {!this.state.classEdit &&
                                <div>
                                    <h2>Search/Edit Classes</h2>
                                    <hr />
                                    <FormItem
                                        label="Certification System"
                                        {...formItemLayout}>
                                        {getFieldDecorator('system', {
                                            initialValue: this.state.filterSystem
                                        })(<Row gutter={8}>
                                            <Col span={18}>
                                                <Select style={{ width: 400 }}
                                                    placeholder="Select the system this class belongs to"
                                                    onChange={this.handleSelectChangeSystem}>
                                                    <Option value="All">All</Option>
                                                    <Option value="TCP">TCP</Option>
                                                    <Option value="ESCC">ESCC</Option>
                                                    <Option value="External Civil Rights Training">External Civil Rights Training</Option>
                                                </Select>
                                            </Col>
                                        </Row>

                                        )}
                                    </FormItem>
                                    <FormItem
                                        {...formItemLayout}
                                        label="Search By Class"
                                    >
                                        <Row gutter={8}>
                                            <Col span={12}>
                                                {/* Search By Class:  */}
                                                {getFieldDecorator('search')(
                                                    <Input size="large" onChange={this.searchTxtChanged} />
                                                )}
                                            </Col>
                                            <Col span={6}>
                                                &nbsp; OR &nbsp;
                                            </Col>
                                        </Row>
                                    </FormItem>
                                    <FormItem
                                        {...formItemLayout}
                                        label="Search By Start Date"
                                    >
                                        <Row gutter={8}>
                                            <Col span={12}>
                                                {getFieldDecorator('date')(
                                                    <Input size="large" onChange={this.dateTxtChanged} placeholder="yyyy-mm-dd" />
                                                )}
                                            </Col>
                                            <Col span={6}>
                                                &nbsp; OR &nbsp;
                                            </Col>
                                        </Row>
                                    </FormItem>
                                    <FormItem
                                        {...formItemLayout}
                                        label="Search By Start Date"
                                    >
                                        <Row gutter={8}>
                                            <Col span={12}>
                                                {/* The below button opens up the calendar 
                                                    Date: 07/26/2019 
                                                    Author: Souradip Roy */}
                                                <img src={require("../img/calendar-icon.gif")} onClick={this.calendar} size="large" style={{ marginLeft: "5px" }}></img>
                                                {/* The below div display the calendar 
                                                    Date: 07/26/2019 
                                                    Author: Souradip Roy */}
                                                <div className="mycalendar" style={{ display: 'none', marginTop: "10px" }}>

                                                    {/* The below is the calendar component
                                                    Date: 07/26/2019 
                                                    Author: Souradip Roy */}
                                                    <Calendar onChange={this.oncalenderChange} value={this.state.date} />

                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={24}>
                                                <button className="btn btn-default" onClick={this.searchClass} size="large">Search</button>
                                                <button className="btn btn-default" onClick={this.searchClassReset} size="large" style={{ marginLeft: "5px" }}>Reset</button>
                                            </Col>
                                        </Row>
                                    </FormItem>
                                    <Table rowKey="Id" bordered columns={columns}
                                        dataSource={this.updateData(this.state.searchClassData, this.state.dateClassData, this.state.searchType)}
                                        pagination={{ pageSize: 30, current: this.state.current, onChange: (page, pageSize) => { this.setState({ current: page }) } }}
                                        onChange={this.handleChangeSort}
                                    />
                                </div>
                            }
                        </div>)
                        : <Redirect to="/login" replace />
                }
            </div>
        );
    }
}

const WrappedEditClass = Form.create()(EditClasses);
export default WrappedEditClass;



// WEBPACK FOOTER //
// ./src/Admin/EditClasses.js